import React, { useMemo } from "react";
import { getRscObject, getEventRSC, getLongEventRSC } from 'helpers/rsc';
import { findArray, RscFromStore, filterArray } from "helpers/utils";
import { useViewport } from 'components/general/useViewPort';
import Label from "components/general/Label";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import WlfAttempt from "./WlfAttempt";
import SportCode from 'components/common/SportCode';

const CurrentCompetitor = ({ data }) => {
    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")

    let rsc = RscFromStore()
    let discipline = getRscObject(rsc).discipline
    let info = data?.results?.extendedInfos;
    let infoCurrent = info?.find(row => row.ei_code === 'CURRENT');
    let resultItems = data?.results?.items;
    let current = infoCurrent?.ei_value;
    let pos = infoCurrent?.ei_pos;
    let athleteItem = resultItems?.find(row => row?.participant?.code === current);
    let athlete = athleteItem?.participant;

    let ifRank = infoCurrent?.extensions?.find(row => row?.eie_code === 'IF_SUCCESS')?.eie_value
    let ifRecord1 = infoCurrent?.extensions?.find(row => row?.eie_code === 'REC_SUCCESS' && row?.eie_pos === '1')?.eie_value
    let ifRecord2 = infoCurrent?.extensions?.find(row => row?.eie_code === 'REC_SUCCESS' && row?.eie_pos === '2')?.eie_value

    let textRank = 'LabelRankIfLiftSuccessful'

    let extendedResultsSntach = athleteItem?.extendedResults?.find(row => row.er_code === 'SNATCH' && row.er_pos === 'TOTAL')
    let recordSntach = extendedResultsSntach?.extensions?.find(row => row.ere_code === 'RECORD' && row.ere_pos === '1')?.ere_value
    let extendedResultsClean = athleteItem?.extendedResults?.find(row => row.er_code === 'CLEAN' && row.er_pos === 'TOTAL')
    let recordClean = extendedResultsClean?.extensions?.find(row => row.ere_code === 'RECORD' && row.ere_pos === '1')?.ere_value

    if (pos === '1' || pos === '2' || pos === '3') {
        textRank = 'LabelIfLiftSuccessful'
    }
    let isClean = false;

    if (pos === "11" || pos === "12" || pos === "13") {
        isClean = true;
    }

    return (
        <>{infoCurrent &&
            <>
                {!isMobile &&
                    <div className="mirs-page-container-current">
                        <table className="table">
                            <caption><Label data="HeaderCurrentCompetitor" /></caption>
                            <thead>
                                <tr>
                                    <th scope="colgroup" className="text-center w-5" rowSpan="2"><Label data="HeaderBib" /></th>
                                    <th scope="colgroup" rowSpan="2"><Label data="HeaderName" /></th>
                                    <th scope="colgroup" className="text-center w-20" colSpan="4"><Label data="HeaderSnatch" sport={discipline} /></th>
                                    <th scope="colgroup" className="text-center w-20" colSpan="4"><Label data="HeaderClean" sport={discipline} /></th>
                                    <th scope="colgroup" className="text-end w-10" rowSpan="2"><Label data="HeaderTotal" /></th>
                                    <th scope="colgroup" className="text-end w-5" rowSpan="2"><Label data="HeaderRank" /></th>
                                </tr>
                                <tr>
                                    <th scope="col" className="text-end w-5">1</th>
                                    <th scope="col" className="text-end w-5">2</th>
                                    <th scope="col" className="text-end w-5">3</th>
                                    <th scope="col" className="text-end"><Label data="HeaderResult" /></th>
                                    <th scope="col" className="text-end w-5">1</th>
                                    <th scope="col" className="text-end w-5">2</th>
                                    <th scope="col" className="text-end w-5">3</th>
                                    <th scope="col" className="text-end"><Label data="HeaderResult" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-end">{athleteItem?.bib}</td>
                                    <td>
                                        <div className="d-flex">
                                            <Noc {...athlete?.organisation} />
                                            <Competitor hidePicture={true} hideNoc={true} {...athlete} />
                                        </div>
                                        <div className="d-flex">
                                            <small>
                                                <Label data={textRank} sport={discipline} />
                                                {ifRank && ifRank}
                                                {ifRecord1 && ifRank && ' /'}
                                                {ifRecord1 && ' '}
                                                {ifRecord1 && <SportCode discipline={discipline} entity='@Success' code={ifRecord1} />}
                                                {ifRecord2 && ', '}
                                                {ifRecord2 && <SportCode discipline={discipline} entity='@Success' code={ifRecord2} />}
                                            </small>
                                        </div>
                                    </td>
                                    <td className={`text-end ${pos === '1' ? 'currentIndicator' : ''}`}>
                                        <WlfAttempt data={athleteItem} code='SNATCH' pos='1' />
                                    </td>
                                    <td className={`text-end ${pos === '2' ? 'currentIndicator' : ''}`}>
                                        <WlfAttempt data={athleteItem} code='SNATCH' pos='2' />
                                    </td>
                                    <td className={`text-end ${pos === '3' ? 'currentIndicator' : ''}`}>
                                        <WlfAttempt data={athleteItem} code='SNATCH' pos='3' />
                                    </td>
                                    <td className="text-end">
                                        <WlfAttempt data={athleteItem} code='SNATCH' pos='TOTAL' /> {recordSntach}
                                    </td>
                                    <td className={`text-end ${pos === '11' ? 'currentIndicator' : ''}`}>
                                        <WlfAttempt data={athleteItem} code='CLEAN' pos='1' />
                                    </td>
                                    <td className={`text-end ${pos === '12' ? 'currentIndicator' : ''}`}>
                                        <WlfAttempt data={athleteItem} code='CLEAN' pos='2' />
                                    </td>
                                    <td className={`text-end ${pos === '13' ? 'currentIndicator' : ''}`}>
                                        <WlfAttempt data={athleteItem} code='CLEAN' pos='3' />
                                    </td>
                                    <td className="text-end">
                                        <WlfAttempt data={athleteItem} code='CLEAN' pos='TOTAL' /> {recordClean}
                                    </td>
                                    <td className="text-end fw-bold">{ResultRecords(athleteItem)}</td>
                                    <td className="text-end fw-bold">{athleteItem?.resultRank}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }
                {isMobile &&
                    <div className="mirs-page-container-current">
                        <table className="table">
                            <thead>
                                <th scope="colgroup" colSpan="4"><Label data="HeaderCurrentCompetitor" /></th>
                                <th scope="colgroup" className="text-end w-5"><Label data="HeaderRank" /></th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan="4">
                                        <div className="d-flex">
                                            <Noc {...athlete?.organisation} />
                                            <Competitor hidePicture={true} hideNoc={true} {...athlete} />
                                        </div>
                                    </td>
                                    <td className="text-end fw-bold">{athleteItem?.resultRank}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <th className="w-15 fw-bold text-end" scope="col">1</th>
                                    <th className="w-15 fw-bold text-end" scope="col">2</th>
                                    <th className="w-15 fw-bold text-end" scope="col">3</th>
                                    <th scope="col" className="w-20 fw-bold text-end"><Label data="HeaderResult" /></th>
                                </tr>
                                <tr>
                                    <th scope="row" className="fw-bold text-end"><Label data="HeaderSnatch" sport={discipline} /></th>
                                    <td className={`text-end ${pos === '1' ? 'currentIndicator' : ''}`}>
                                        <WlfAttempt data={athleteItem} code='SNATCH' pos='1' />
                                    </td>
                                    <td className={`text-end ${pos === '2' ? 'currentIndicator' : ''}`}>
                                        <WlfAttempt data={athleteItem} code='SNATCH' pos='2' />
                                    </td>
                                    <td className={`text-end ${pos === '3' ? 'currentIndicator' : ''}`}>
                                        <WlfAttempt data={athleteItem} code='SNATCH' pos='3' />
                                    </td>
                                    <td className="text-end">
                                        <WlfAttempt data={athleteItem} code='SNATCH' pos='TOTAL' /> {recordSntach}
                                    </td>
                                </tr>
                                {isClean &&
                                    <>
                                        <tr>
                                            <th scope="row" className="fw-bold text-end"><Label data="HeaderClean" sport={discipline} /></th>
                                            <td className={`text-end ${pos === '11' ? 'currentIndicator' : ''}`}>
                                                <WlfAttempt data={athleteItem} code='CLEAN' pos='1' />
                                            </td>
                                            <td className={`text-end ${pos === '12' ? 'currentIndicator' : ''}`}>
                                                <WlfAttempt data={athleteItem} code='CLEAN' pos='2' />
                                            </td>
                                            <td className={`text-end ${pos === '13' ? 'currentIndicator' : ''}`}>
                                                <WlfAttempt data={athleteItem} code='CLEAN' pos='3' />
                                            </td>
                                            <td className="text-end">
                                                <WlfAttempt data={athleteItem} code='CLEAN' pos='TOTAL' /> {recordClean}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row" className="fw-bold text-end"><Label data="HeaderTotal" sport={discipline} /></th>
                                            <td colSpan="3"></td>
                                            <td className="text-end fw-bold">{ResultRecords(athleteItem)}</td>
                                        </tr>
                                    </>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </>
        }
        </>
    )

}

export default CurrentCompetitor;

function ResultRecords(data) {

    let row = data
    let rsc = RscFromStore()
    let discipline = getRscObject(rsc).discipline
    let event = getLongEventRSC(rsc)
    let rowNumberIrm = findArray(row.extendedResults, { er_code: ['IRM_LAP'] })
    let numberIrm = rowNumberIrm?.er_value || ''
    let resultIrm = (row.resultIrm)
    let recordEvent = getEventRSC(rsc)
    let min = 1;

    let arrRecordIndicator = filterArray(row.recordIndicators, { ri_code: [event] });
    if (Array.isArray(arrRecordIndicator) && arrRecordIndicator.length > 0) {
        min = Math.min.apply(Math, arrRecordIndicator.map(function (o) {
            return o.ri_order;
        }));
    }

    row?.recordIndicators
        ? row.recordIndicators.filter(row => row.ri_order === min && getEventRSC(row.ri_code) === recordEvent).map((val) => {
            arrRecordIndicator = (val.ri_equalled === 'Y' ? '=' : '') + val.ri_recordtype
        })
        : arrRecordIndicator = ''

    let irmObject = {}
    switch (resultIrm) {
        case 'DNF':
            irmObject = <><SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />{numberIrm}</>
            break;
        case 'LAP':
            irmObject = <>{numberIrm}<SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} /></>
            break;
        default:
            irmObject = <SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />
            break;
    }

    return (
        row.resultType === 'IRM'
            ? <>{irmObject} {arrRecordIndicator}</>
            : <>{row.resultData} {arrRecordIndicator}</>
    )

}